module.exports = __webpack_public_path__ + "static/img/master-bl-banner.4b82ce9d.png";